// src/components/MoreSection.js - RULING 276 item 2 (Bob 2026-10-03, "agreed"): every screen does one job; what is not that
// job moves behind a "More" control on the same screen, and NOTHING IS DELETED. The section stays mounted while it is
// closed (display:none), so a panel that reports state upward keeps reporting it; and a section that needs the reader
// (forceOpen) opens itself and says why.
import React, { useState } from 'react';

export default function MoreSection({ label, children, forceOpen, why }) {
  const [open, setOpen] = useState(false);
  const shown = open || !!forceOpen;
  return (
    <div style={{ marginBottom: shown ? 4 : 10 }}>
      <button type="button" className="btn btn-secondary btn-sm" aria-expanded={shown} onClick={() => setOpen(!open)}
        style={{ fontSize: 12, marginBottom: shown ? 8 : 0 }}>
        {(shown ? 'Hide: ' : 'More: ') + label}
      </button>
      {forceOpen && !open ? <span style={{ fontSize: 11, color: '#E8A020', marginLeft: 8 }}>{why || 'Open because it needs you.'}</span> : null}
      <div style={{ display: shown ? 'block' : 'none' }}>{children}</div>
    </div>
  );
}
